import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.push.js";
import $ from 'jquery';
import { userName, verificationCode } from '@/api/user';
import { isPhone, isEmail } from '@/utils/validate';
export default {
  data: function data() {
    return {
      isActive: false,
      checked: false,
      userName: '',
      verificationCode: '',
      countryCode: localStorage.getItem('countryCode') || '+86',
      country: localStorage.getItem('country') || 'china'
    };
  },
  created: function created() {},
  methods: {
    input: function input() {
      if (this.userName.trim() !== '' && this.verificationCode.trim() !== '') {
        if (isPhone(this.userName) || isEmail(this.userName)) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
      } else {
        this.isActive = false;
      }
    },
    focus: function focus(dom) {
      $(dom).css('border-image', '-webkit-linear-gradient(#6EDCF5 0%, #6EDCF5 100%) 0 0 100 0');
    },
    blur: function blur(dom) {
      $(dom).css('border-image', 'none');
    },
    loginIn: function loginIn(params) {
      var _this = this;
      userName(params).then(function (res) {
        if (res.code === 0) {
          _this.$router.push({
            path: '/vehicleControl'
          });
        } else {
          _this.$toast(res.message);
        }
      });
    },
    toLoginWithPassword: function toLoginWithPassword() {
      this.$router.push({
        path: '/login'
      });
    },
    send: function send() {
      var _this2 = this;
      var params = {};
      params.targetName = this.userName;
      params.operationType = 0;
      if (isPhone(this.userName)) {
        params.countryCode = this.countryCode;
        params.targetType = 1;
      } else {
        if (isEmail(this.userName)) {
          params.targetType = 2;
          delete params.countryCode;
        } else {
          if (this.userName) {
            this.$toast('用户名格式不正确');
          } else {
            this.$toast('请输入用户名');
          }
          return;
        }
      }
      verificationCode(params).then(function (res) {
        if (res.code === 0) {
          _this2.$toast('发送完成');
        } else {
          _this2.$toast(res.message);
        }
      });
    },
    toLogin: function toLogin() {
      if (this.userName.trim() !== '' && this.verificationCode.trim() !== '') {
        if (this.checked) {
          var params = {};
          params.userName = this.userName;
          params.verificationCode = this.verificationCode;
          if (isPhone(this.userName)) {
            params.countryCode = this.countryCode;
            params.accountType = '1';
          } else {
            if (isEmail(this.userName)) {
              params.accountType = '2';
              delete params.countryCode;
            } else {
              this.$toast('用户名格式不正确');
              return;
            }
          }
          this.loginIn(params);
        } else {
          this.$toast('未同意条款');
        }
      } else {
        this.$toast('请输入完整信息');
      }
    },
    getCountry: function getCountry() {
      this.$router.push({
        path: '/selectCountry'
      });
    },
    forgetPassword: function forgetPassword() {
      this.$router.push({
        path: '/forgetPassword'
      });
    },
    back: function back() {
      this.$router.back();
    },
    toRefister: function toRefister() {
      this.$router.push({
        path: '/register'
      });
    }
  }
};